import { h } from 'preact';
export const Instagram = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "2", y: "2", width: "20", height: "20", rx: "5", ry: "5" }),
        h("path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" }),
        h("line", { x1: "17.5", y1: "6.5", x2: "17.51", y2: "6.5" })));
};
//# sourceMappingURL=instagram.js.map